import { FC } from "react";

interface IProps {
  transform?: "scale(1 -1)" | "scale(1 1)";
  className?: string;
}

export const ArrowDown: FC<IProps> = ({ transform, className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={transform}
      className={className}
    >
      <path
        d="M7.99904 11.2004C7.53237 11.2004 7.0657 11.0204 6.71237 10.6671L2.3657 6.32042C2.17237 6.12708 2.17237 5.80708 2.3657 5.61375C2.55904 5.42042 2.87904 5.42042 3.07237 5.61375L7.41904 9.96042C7.73904 10.2804 8.25904 10.2804 8.57904 9.96042L12.9257 5.61375C13.119 5.42042 13.439 5.42042 13.6324 5.61375C13.8257 5.80708 13.8257 6.12708 13.6324 6.32042L9.2857 10.6671C8.93237 11.0204 8.4657 11.2004 7.99904 11.2004Z"
        fill="#4A5368"
      />
    </svg>
  );
};
